document.addEventListener("DOMContentLoaded", function() {
  const lazyImages = document.querySelectorAll(".download-device-item .lazy-image");

  lazyImages.forEach(img => {
    img.addEventListener("load", () => {
      img.style.opacity = 1; // 画像が読み込まれたら表示
    });

    img.setAttribute("src", img.getAttribute("data-src"));
  });
});